import { render } from "./PageLoaderMobile.vue?vue&type=template&id=e0955224&scoped=true"
import script from "./PageLoaderMobile.vue?vue&type=script&lang=js"
export * from "./PageLoaderMobile.vue?vue&type=script&lang=js"

import "./PageLoaderMobile.vue?vue&type=style&index=0&id=e0955224&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0955224"]])

export default __exports__